// https://vuex.vuejs.org/en/mutations.html
import { TokenService } from '../services/storage.service'

export default {
  //
  setClient (state, clientInfo) {
    state.client = clientInfo
    TokenService.saveLoginCode(clientInfo['client_code'])
    state.company_name = clientInfo['client_name']
    state.company_logo = clientInfo['client_logo']
  },

  setRetail (state, retailInfo) {
    state.retail = retailInfo
    TokenService.saveLoginCode(retailInfo['retail_code'])
    state.company_name = retailInfo['retail_name']
    state.company_logo = retailInfo['retail_logo']
  },

  setRecaps (state, recaps) {
    state.recaps = recaps
  },

  setStates (state, stateList) {
    state.stateList = stateList
  },

  setWorkOrders (state, workOrders) {
    state.workOrders = workOrders
  },

  setStoreTypes (state, storeTypes) {
    state.storeTypes = storeTypes
  },

  setAgenciesList (state, agenciesList) {
    state.agenciesList = agenciesList
  },

  setDistributorsList (state, distributorsList) {
    state.distributorsList = distributorsList
  },

  setDistributorFilter (state, distributorFilter) {
    state.distributorFilter = distributorFilter
  },

  setBrandsList (state, brandsList) {
    state.brandsList = brandsList
  },

  setBrandFilter (state, brandFilter) {
    state.brandFilter = brandFilter
  },

  setStats (state, stats) {
    state.statistics = stats
  },

  setSchedule (state, schedule) {
    state.schedule = schedule
  },

  setSales (state, sales) {
    state.sales = sales
  },

  setTopAgencies (state, agenciesData) {
    state.agencies = agenciesData
  },

  setStoreSales (state, storeSales) {
    state.storeSales = storeSales
  },

  setSupplierSales (state, supplierSales) {
    state.supplierSales = supplierSales
  },

  setRetailStoreSales (state, retailStoreSales) {
    state.retailStoreSales = retailStoreSales
  },

  setStateFilter (state, stateFilter) {
    state.stateFilter = stateFilter
  },

  setAgencyFilter (state, agencyFilter) {
    state.agencyFilter = agencyFilter
  },

  setAgencyView (state, agencyView) {
    state.agencyView = agencyView
  },

  setBrandView (state, brandView) {
    state.brandView = brandView
  },

  // Toggle distributor filter visibility for client tenants
  setDistributorView (state, distributorView) {
    state.distributorView = distributorView
  },

  setWorkOrderFilter (state, workOrderFilter) {
    state.workOrderFilter = workOrderFilter
  },

  setStoreFilter (state, storeFilter) {
    state.storeFilter = storeFilter
  },

  setDateFrom (state, dateFrom) {
    state.dateFrom = dateFrom
  },

  setDateTo (state, dateTo) {
    state.dateTo = dateTo
  },

  setScheduleDateFrom (state, scheduleDateFrom) {
    state.scheduleDateFrom = scheduleDateFrom
  },

  setScheduleDateTo (state, scheduleDateTo) {
    state.scheduleDateTo = scheduleDateTo
  },

  setApiRoot (state, apiRoot) {
    state.apiRoot = apiRoot
  },

  setConfigError (state, message) {
    state.configError = message || null
  },

  setAccessKey (state, accessKey) {
    TokenService.saveAccessKey(accessKey)
    state.accessKey = accessKey
    state.authenticating = false
  },

  setUserProfile (state, profile) {
    state.userProfile = profile || null
    TokenService.saveUserProfile(profile)
  },

  clientLoadError (state, {errorCode, errorMessage}) {
    state.authenticating = false
    state.authenticationErrorCode = errorCode
    state.authenticationError = errorMessage
    state.login_type = ''
    TokenService.removeLoginType()
  },

  retailLoadError (state, {errorCode, errorMessage}) {
    state.authenticating = false
    state.authenticationErrorCode = errorCode
    state.authenticationError = errorMessage
    state.login_type = ''
    TokenService.removeLoginType()
  },

  clientLoad (state) {
    state.company_name = ''
    state.login_type = 'client'
    TokenService.saveLoginType('client')
    state.authenticating = true
    state.authenticationError = ''
    state.authenticationErrorCode = 0
  },

  retailLoad (state) {
    state.company_name = ''
    state.login_type = 'retail'
    TokenService.saveLoginType('retail')
    state.authenticating = true
    state.authenticationError = ''
    state.authenticationErrorCode = 0
  },

  setLoginCredentials (state, { code, accessKey, type, username, user }) {
    state.loginCredentials.code = code
    state.loginCredentials.accessKey = accessKey
    state.loginCredentials.type = type
    state.loginCredentials.username = username
    if (user !== undefined) {
      state.userProfile = user || null
      TokenService.saveUserProfile(user)
    }
  }

}
